const imgUrl = [
  require('../../../assets/img/solutions/校车.png'),
  require('../../../assets/img/solutions/schoolBus/map1.png'),
  require('../../../assets/img/solutions/schoolBus/car1.png'),
  require('../../../assets/img/solutions/schoolBus/map2.png'),
  require('../../../assets/img/solutions/schoolBus/car2.png'),
  require('../../../assets/img/solutions/schoolBus/map2_val.png'),
  require('../../../assets/img/solutions/schoolBus/phone.png'),
  require('../../../assets/img/solutions/schoolBus/pc.png'),
  require('../../../assets/img/solutions/schoolBus/alarm.png'),
];

export default imgUrl;
